import { render, staticRenderFns } from "./Stammdaten.vue?vue&type=template&id=482b4f9a"
import script from "./Stammdaten.vue?vue&type=script&lang=js"
export * from "./Stammdaten.vue?vue&type=script&lang=js"
import style0 from "./Stammdaten.vue?vue&type=style&index=0&id=482b4f9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports